import { Box, Alert } from '@mui/material';
import { TrendingUp, People, AttachMoney, Assessment } from '@mui/icons-material';
import { useDashboardStats } from '../../hooks';
import { StatCard, StatCardSkeleton } from '../common/StatCard';
import Grid from '@mui/material/Grid';

export const DashboardStats = () => {
  const { stats, isLoading, error } = useDashboardStats();

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 3 }}>
        Failed to load dashboard statistics. Please try again.
      </Alert>
    );
  }

  const statCards = [
    {
      title: 'Total Revenue',
      value: `KES ${stats?.total_revenue?.toLocaleString() || 0}`,
      icon: <AttachMoney />,
      color: '#10b981',
      trend: {
        value: '12.5%',
        isPositive: true,
      },
    },
    {
      title: 'Transactions',
      value: stats?.total_transactions?.toLocaleString() || 0,
      icon: <TrendingUp />,
      color: '#3b82f6',
      trend: {
        value: '8.3%',
        isPositive: true,
      },
    },
    {
      title: 'Customers',
      value: stats?.total_customers?.toLocaleString() || 0,
      icon: <People />,
      color: '#f59e0b',
      trend: {
        value: '15.2%',
        isPositive: true,
      },
    },
    {
      title: 'Active Services',
      value: stats?.total_services?.toLocaleString() || 0,
      icon: <Assessment />,
      color: '#8b5cf6',
      trend: {
        value: '3.1%',
        isPositive: false,
      },
    },
  ];

  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      {isLoading ? (
        <StatCardSkeleton count={4} />
      ) : (
        statCards.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
            <StatCard
              title={card.title}
              value={card.value}
              icon={card.icon}
              color={card.color}
              trend={card.trend}
              delay={index * 100}
            />
          </Grid>
        ))
      )}
    </Grid>
  );
};
